module.exports = __webpack_public_path__ + "static/media/22.a6c5479d.png";